/**
Copyright (C) 2019-2022, Infraclear Inc. All Rights Reserved.
*/


// DEV -- npm start
    //    npm run build

// QA -- npm run start:qa
    //    npm run build:qa


// PROD -- npm run start:prod
    //    npm run build:prod

// PROD -- npm run start:refprod
    //    npm run build:refprod


export let endPoint = process.env.REACT_APP_API_ENDPOINT;
export let apiBasePath =process.env.REACT_APP_API_BASE_PATH_AUTH;
export let accessMangerBasePath =process.env.REACT_APP_ACCESS_MANGER_BASE_PATH;
export let docVerificationBasePath = process.env.REACT_APP_DOC_VERIFICATION_BASE_PATH;
export let docSearchBasePath =process.env.REACT_APP_DOC_SEARCH_BASE_PATH;
export let docAcqBasePath = process.env.REACT_APP_DOC_ACQ_BASE_PATH;
export let refDataBasepath =process.env.REACT_APP_REF_DATA_BASE_PATH;
export let passwordLength:any = process.env.REACT_APP_PASSWORD_LENGTH;
export let convertKey:any = process.env.REACT_APP_PASSPHRASE;
export let saltKey:any = process.env.REACT_APP_SALT;
export let apiBasePathSearch=process.env.REACT_APP_API_BASE_PATH_SEARCH;
export let apiBasePathUserDetail=process.env.REACT_APP_API_BASE_PATH_USER_DETAIL;

export const muiLicense = process.env.REACT_APP_MUI_LICENSE;
export const ssoAppUrl= process.env.REACT_APP_SSO_APP_URL;
export const ssoAppRedirectUrl = process.env.REACT_APP_SSO_REDIRECT_URL;
export const basicUserDownloadProductUrl = process.env.REACT_APP_BASIC_ACCESS_DOWNLOAD_PRODUCT_PATH;
export const limitedUserSubscriptionUrl = process.env.REACT_APP_BASIC_ACCESS_SUBSCRIBER;
export const proUserSubscriptionUrl = process.env.REACT_APP_PRO_ACCESS_SUBSCRIBER;
export const proUserDownloadProductUrl = process.env.REACT_APP_PRO_ACCESS_DOWNLOAD_PRODUCT_PATH;
export const googleAppUrl = process.env.REACT_APP_GOOGLE_APP_URL;
export const googleAppRedirectUrl = process.env.REACT_APP_GOOGLE_REDIRECT_URL;